import { currencyFormatter } from '@/helpers/currencyFormatter';
import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const DirectPaymentLinkSent = ({ event }: { event: any }) => {
  const sentTo = event.data?.sentTo;
  const deliveryMethod: 'email' | 'sms' = event.data?.deliveryMethod === 'sms' ? 'sms' : 'email';
  const channelLabel = deliveryMethod === 'sms' ? 'SMS' : 'email';
  const minAllowedPayment: number | undefined = event.data?.minAllowedPayment;
  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> sent a direct payment link via {channelLabel}
        {sentTo ? ` to ${sentTo}` : ''}
        {minAllowedPayment !== undefined && minAllowedPayment > 0
          ? ` with a minimum payment of ${currencyFormatter.format(minAllowedPayment)}`
          : ''}
      </Box>
    </Box>
  );
};

export default DirectPaymentLinkSent;
